import { useCurrentFrame, useVideoConfig, interpolate, Easing, AbsoluteFill } from "remotion";
import { loadFont as loadInter } from "@remotion/google-fonts/Inter";
const { fontFamily: inter } = loadInter("normal", { weights: ["700","800"], subsets: ["latin"] });

// Portrait LS Variant 4 — Notification ping, centre-screen
export const ReelLS4: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const scaleIn  = interpolate(frame, [0, Math.round(fps*0.4)], [0.6,1], { extrapolateRight:"clamp", extrapolateLeft:"clamp", easing: Easing.bezier(0.34,1.56,0.64,1) });
  const fadeIn   = interpolate(frame, [0, Math.round(fps*0.3)], [0,1], { extrapolateRight:"clamp", extrapolateLeft:"clamp" });
  const fadeOut  = interpolate(frame, [Math.round(fps*5), Math.round(fps*6)], [1,0], { extrapolateLeft:"clamp", extrapolateRight:"clamp" });
  const pingR    = interpolate(frame, [Math.round(fps*0.4), Math.round(fps*1.2)], [0,60], { extrapolateRight:"clamp", extrapolateLeft:"clamp" });
  const pingOp   = interpolate(frame, [Math.round(fps*0.4), Math.round(fps*1.2)], [0.6,0], { extrapolateRight:"clamp", extrapolateLeft:"clamp" });
  const likeClicked = frame >= Math.round(fps*1.6);
  const subClicked  = frame >= Math.round(fps*2.4);
  const likeS = interpolate(frame, [Math.round(fps*1.6), Math.round(fps*1.68), Math.round(fps*1.8)], [1,0.86,1.06], { extrapolateRight:"clamp", extrapolateLeft:"clamp" });
  const subS  = interpolate(frame, [Math.round(fps*2.4), Math.round(fps*2.48), Math.round(fps*2.6)], [1,0.86,1.06], { extrapolateRight:"clamp", extrapolateLeft:"clamp" });
  return (
    <AbsoluteFill style={{ overflow:"hidden" }}>
      <div style={{ position:"absolute", inset:0, display:"flex", alignItems:"center", justifyContent:"center", opacity: fadeIn*fadeOut }}>
        <div style={{ transform:`scale(${scaleIn})`, display:"flex", flexDirection:"column", alignItems:"center", gap:12, position:"relative" }}>
          {/* ping rings */}
          <div style={{ position:"absolute", top:"50%", left:"50%", width:pingR*2, height:pingR*2, marginLeft:-pingR, marginTop:-pingR, borderRadius:"50%", border:"2px solid rgba(255,215,0,0.6)", opacity:pingOp, pointerEvents:"none" }} />
          <div style={{ fontSize:52, lineHeight:1, filter:"drop-shadow(0 6px 20px rgba(255,215,0,0.8))" }}>🔔</div>
          <div style={{ background:"rgba(12,12,12,0.9)", backdropFilter:"blur(12px)", borderRadius:14, padding:"12px 24px", border:"1px solid rgba(255,215,0,0.35)", boxShadow:"0 8px 32px rgba(0,0,0,0.7)", display:"flex", flexDirection:"column", alignItems:"center", gap:10 }}>
            <span style={{ color:"#FFD700", fontSize:10, fontWeight:700, fontFamily:inter, letterSpacing:1.2, textTransform:"uppercase" }}>Deva Katha</span>
            <div style={{ display:"flex", gap:10, width:"100%" }}>
              <div style={{ flex:1, display:"flex", alignItems:"center", justifyContent:"center", gap:4, background: likeClicked?"#1a73e8":"rgba(255,255,255,0.1)", border:`1px solid ${likeClicked?"#1a73e8":"rgba(255,255,255,0.2)"}`, borderRadius:22, padding:"8px 0", transform:`scale(${likeS})`, boxShadow: likeClicked?"0 4px 14px rgba(26,115,232,0.55)":"none" }}>
                <span style={{ color:"#fff", fontSize:12, fontWeight:800, fontFamily:inter, whiteSpace:"nowrap" }}>👍 {likeClicked?"Liked!":"Like"}</span>
              </div>
              <div style={{ flex:1, display:"flex", alignItems:"center", justifyContent:"center", background: subClicked?"#555":"#FF0000", borderRadius:22, padding:"8px 0", transform:`scale(${subS})`, boxShadow: subClicked?"none":"0 4px 18px rgba(255,0,0,0.55)" }}>
                <span style={{ color:"#fff", fontSize:12, fontWeight:800, fontFamily:inter, whiteSpace:"nowrap" }}>{subClicked?"Subscribed ✓":"Subscribe"}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
